import React from 'react';

function ContentPage({ headingData }) {
  return (
    <>
      <span className="vertical-line" />
      <table className="table custom-table">
        <tr>
          <td className="border-none" colSpan="2">
            <div className="conten-title">
              <p>Table of</p>
              <p>Content</p>
            </div>
          </td>
        </tr>
        {headingData?.map((element) => {
          return (
            element?.control && (
              <tr key={element?._id}>
                <td style={{ width: '10%' }} className="text-center">
                  {element?.pageIndex}
                </td>
                <td style={{ width: '90%' }}>{element?.control?.value}</td>
              </tr>
            )
          );
        })}
      </table>
    </>
  );
}

export default ContentPage;
